
import auth from '@/lib/auth';
import Cookies from 'js-cookie';
import { getApi } from '../../comm/middleware/callApi';
import apis from '../../comm/api/apis';
import {initNimSDK} from './initNimSDK';
import {sendMsg, sendFileMsg, sendFormatMsg, sendMsgReceipt, sendRobotMsg, revocateMsg, updateLocalMsg, getHistoryMsgs, resetNoMoreHistoryMsgs, continueRobotMsg} from './msgs'
import {deleteSession, setCurrSession, resetCurrSession} from './session'
import { delegateTeamFunction, onTeamNotificationMsg, enterSettingPage, getTeamMembers, checkTeamMsgReceipt, getTeamMsgReads} from './team'


function connectNim ({state, commit, dispatch}, obj) {
    let {force} = Object.assign({}, obj)

    const expertInfo =  state.expertInfo;
    //const uid = getEncUserId(state);
    //如果uid不存在，跳转到登录页面.可能需要区分是否为专家端.
    if(!expertInfo || !expertInfo.id){
      auth.login('expert', null);
    }

    getApi({ commit }, apis.getNimToken,  { expertid: expertInfo.id  })
    .then((data) => {
        const expert = data.data;
        const accId = expert.accId;
        const accToken = expert.accToken

        // 操作为内容页刷新页面，此时无nim实例
        if (!state.nim || force) {
            let loginInfo = {
                uid: accId,
                sdktoken: accToken,
            }

            if (!loginInfo.uid) {
              auth.login('expert', null);
            } else {
                // 有cookie，重新登录
                dispatch('initNimSDK', loginInfo);
            }
        }
    });
}

// function getEncUserId(state){
//     const userInfo = state.userInfo;
//     const expertInfo =  state.expertInfo;
//     //如果是普通用户.
//     if(userInfo && userInfo.encUserId){
//         return userInfo.encUserId;
//     }
//     //如果是专家.
//     if(expertInfo && expertInfo.token){
//         // const token = expertInfo.token;
//         // const arr = token.split('_');
//         // return arr.length > 0 ? arr[0] : null;
//         return `exp_${expertInfo.id}`;
//     }

//     return null;
// }


// export const updateRefreshState = ({commit}) => {
//     commit('updateRefreshState');
// };

// 连接sdk请求，false表示强制重连
export const connect = (store, obj) => {
    let {type} = Object.assign({}, obj)
    // type 可为 nim chatroom
    type = type || 'nim'
    switch (type) {
    case 'nim':
        connectNim(store, obj)
        break
    case 'chatroom':
        //do nothing
        break
    }
};

// 从服务端获取音频
export const getRecord = ({ commit }, { media_id, media_type = 2 }) => {
  return getApi({ commit }, apis.getRecord, { media_id, media_type })
  .then((body) => {
    return body.data;
  });
};

export {
  initNimSDK,
  sendMsg,
  sendFileMsg,
  sendFormatMsg,
  sendMsgReceipt,
  revocateMsg,
  updateLocalMsg,
  getHistoryMsgs,
  deleteSession,
  setCurrSession,
  resetCurrSession,

  delegateTeamFunction,
  onTeamNotificationMsg,
  enterSettingPage,
  getTeamMembers,
  checkTeamMsgReceipt,
  getTeamMsgReads
}
// 重置历史消息状态
//export const resetNoMoreHistoryMsgs = resetNoMoreHistoryMsgs;



// WEBPACK FOOTER //
// ./src/store/nim/actions.nim.js